import type { AppLocale, MessageTree } from "@airange/shared/i18n-common";

export const redblueActivityLifecyclePageMessages: Record<AppLocale, MessageTree> = {
  "zh-CN": {
    redblue: {
      pages: {
        activityDetail: {
          lifecycle: {
            scheduleLabel: "发布演练",
            scheduleConfirm: "确认发布演练并进入已排期状态？发布后会冻结当前活动设计快照。",
            scheduleSuccess: "演练已发布并进入已排期",
            scheduleBlockedTitle: "发布演练前需要补齐以下后端校验项",
            readinessIssues: {
              activityNotDraft: "活动必须处于草稿状态才能发布。",
              scheduleWindowInvalid: "结束时间必须晚于开始时间。",
              sourceSchemeVersionMissing: "活动需要关联来源演练方案版本。",
              sourceSchemeVersionNotFound: "活动关联的来源演练方案版本不存在。",
              sourceSchemeVersionNotPublished: "来源演练方案版本必须已发布。",
              topologyBindingMissing: "发布前需要绑定动态靶场拓扑版本。",
              topologyBindingIncomplete: "活动拓扑绑定合同不完整，请重新检查拓扑绑定。",
              activityCampsMissing: "活动至少需要一个阵营。",
              activitySeatsMissing: "活动至少需要一个席位。",
              activityTasksMissing: "活动至少需要一个任务。",
              reportTemplatesInvalid: "来源演练方案版本的报告模板合同无效。",
              reportTemplatesMissing: "来源演练方案版本至少需要一个报告模板。",
              membersMissing: "活动至少需要配置一名成员。",
              seatsNotFullyBound: "仍有活动席位没有绑定成员，请在“成员与席位”页签补齐。",
              unknown: "未知发布阻断项：{code}",
            },
            prepareLabel: "进入准备中",
            prepareConfirm: "确认将演练切换到准备中？",
            prepareSuccess: "演练已切换到准备中",
            startLabel: "开始演练",
            startConfirm: "确认开始演练？",
            startSuccess: "演练已开始",
            endLabel: "结束演练",
            endConfirm: "确认结束演练？结束后不能补交报告。",
            endSuccess: "演练已结束",
            archiveLabel: "归档演练",
            archiveConfirm: "确认归档演练？",
            archiveSuccess: "演练已归档",
          },
        },
      },
    },
  },
  en: {
    redblue: {
      pages: {
        activityDetail: {
          lifecycle: {
            scheduleLabel: "Publish Activity",
            scheduleConfirm:
              "Publish this activity and move it to scheduled? This freezes the current activity design snapshot.",
            scheduleSuccess: "Activity published and moved to scheduled",
            scheduleBlockedTitle: "Complete these backend readiness checks before publishing",
            readinessIssues: {
              activityNotDraft: "The activity must be in draft status before publishing.",
              scheduleWindowInvalid: "The end time must be later than the start time.",
              sourceSchemeVersionMissing: "The activity needs a source exercise scheme version.",
              sourceSchemeVersionNotFound: "The source exercise scheme version no longer exists.",
              sourceSchemeVersionNotPublished:
                "The source exercise scheme version must be published.",
              topologyBindingMissing: "Bind a dynamic range topology version before publishing.",
              topologyBindingIncomplete:
                "The activity topology binding contract is incomplete. Recheck the topology binding.",
              activityCampsMissing: "Configure at least one camp for the activity.",
              activitySeatsMissing: "Configure at least one seat for the activity.",
              activityTasksMissing: "Configure at least one task for the activity.",
              reportTemplatesInvalid:
                "The source exercise scheme version has an invalid report template contract.",
              reportTemplatesMissing:
                "Configure at least one report template on the source exercise scheme version.",
              membersMissing: "Configure at least one activity member.",
              seatsNotFullyBound:
                "Some activity seats are not bound to members. Complete them in Members and Seats.",
              unknown: "Unknown publish blocker: {code}",
            },
            prepareLabel: "Move to Preparing",
            prepareConfirm: "Move this activity to preparing?",
            prepareSuccess: "Activity moved to preparing",
            startLabel: "Start Activity",
            startConfirm: "Start this activity?",
            startSuccess: "Activity started",
            endLabel: "End Activity",
            endConfirm: "End this activity? Reports cannot be submitted afterward.",
            endSuccess: "Activity ended",
            archiveLabel: "Archive Activity",
            archiveConfirm: "Archive this activity?",
            archiveSuccess: "Activity archived",
          },
        },
      },
    },
  },
  ja: {
    redblue: {
      pages: {
        activityDetail: {
          lifecycle: {
            scheduleLabel: "演習を公開",
            scheduleConfirm:
              "この演習を公開して予定済みに移行しますか？現在の活動設計スナップショットを固定します。",
            scheduleSuccess: "演習を公開し、予定済みに移行しました",
            scheduleBlockedTitle: "公開前に以下のバックエンド準備チェックを完了してください",
            readinessIssues: {
              activityNotDraft: "活動は下書き状態でなければ公開できません。",
              scheduleWindowInvalid: "終了時刻は開始時刻より後にしてください。",
              sourceSchemeVersionMissing: "活動には元になる演練方案バージョンが必要です。",
              sourceSchemeVersionNotFound: "元になる演練方案バージョンが存在しません。",
              sourceSchemeVersionNotPublished:
                "元になる演練方案バージョンは公開済みである必要があります。",
              topologyBindingMissing:
                "公開前に動的レンジのトポロジーバージョンを紐付けてください。",
              topologyBindingIncomplete:
                "活動トポロジー紐付けの契約が不完全です。トポロジー紐付けを再確認してください。",
              activityCampsMissing: "活動には少なくとも1つの陣営が必要です。",
              activitySeatsMissing: "活動には少なくとも1つの席位が必要です。",
              activityTasksMissing: "活動には少なくとも1つのタスクが必要です。",
              reportTemplatesInvalid:
                "元になる演練方案バージョンのレポートテンプレート契約が不正です。",
              reportTemplatesMissing:
                "元になる演練方案バージョンに少なくとも1つのレポートテンプレートを設定してください。",
              membersMissing: "活動には少なくとも1人のメンバーを設定してください。",
              seatsNotFullyBound:
                "メンバー未割り当ての席位があります。「メンバーと席位」タブで補完してください。",
              unknown: "不明な公開ブロッカー: {code}",
            },
            prepareLabel: "準備中へ移行",
            prepareConfirm: "この演習を準備中へ移行しますか？",
            prepareSuccess: "演習を準備中へ移行しました",
            startLabel: "演習を開始",
            startConfirm: "この演習を開始しますか？",
            startSuccess: "演習を開始しました",
            endLabel: "演習を終了",
            endConfirm: "この演習を終了しますか？終了後はレポートを追加提出できません。",
            endSuccess: "演習を終了しました",
            archiveLabel: "演習をアーカイブ",
            archiveConfirm: "この演習をアーカイブしますか？",
            archiveSuccess: "演習をアーカイブしました",
          },
        },
      },
    },
  },
};
